import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin-service';
import {
  PendingPlatePhoto,
  PlatePhotoReviewService,
} from 'src/app/services/plate-photo-review.service';

// Admin moderation queue for member-submitted plate photos (Plate Image
// Researcher). Member uploads land pending and are NOT public until approved
// here. Each card shows the photo, the registration it is filed under and the
// car details, with approve / reject. Verify-gated like the editorial queue.
@Component({
  selector: 'pla-admin-plate-photos',
  templateUrl: './admin-plate-photos.component.html',
  styleUrls: ['./admin-plate-photos.component.scss'],
})
export class AdminPlatePhotosComponent implements OnInit {
  public verified = false;
  public loading = true;
  public photos: PendingPlatePhoto[] = [];
  public acting = new Set<string>();
  public error = '';
  public toast = '';
  private toastTimer: any = null;

  constructor(
    private router: Router,
    private admin: AdminService,
    private review: PlatePhotoReviewService
  ) {}

  ngOnInit(): void {
    this.admin.verify().subscribe(
      (data: { admin: boolean }) => {
        if (!data || !data.admin) {
          this.router.navigate(['/landing']);
          return;
        }
        this.verified = true;
        this.load();
      },
      () => this.router.navigate(['/landing'])
    );
  }

  public load(): void {
    this.loading = true;
    this.error = '';
    this.review.pending().then(
      (rows) => {
        this.photos = rows || [];
        this.loading = false;
      },
      () => {
        this.photos = [];
        this.loading = false;
        this.error = 'Could not load the queue. Try signing out and back in.';
      }
    );
  }

  public approve(p: PendingPlatePhoto): void {
    if (this.acting.has(p.id)) return;
    this.acting.add(p.id);
    this.review.approve(p.id).then(
      () => this.remove(p, `${p.registration} approved. It now shows on the plate's timeline.`),
      () => this.fail(p)
    );
  }

  public reject(p: PendingPlatePhoto): void {
    if (this.acting.has(p.id)) return;
    this.acting.add(p.id);
    this.review.reject(p.id).then(
      () => this.remove(p, `${p.registration} rejected`),
      () => this.fail(p)
    );
  }

  private remove(p: PendingPlatePhoto, msg: string): void {
    this.photos = this.photos.filter((x) => x.id !== p.id);
    this.acting.delete(p.id);
    this.showToast(msg);
  }

  private fail(p: PendingPlatePhoto): void {
    this.acting.delete(p.id);
    this.showToast('Could not complete that just now.');
  }

  private showToast(msg: string): void {
    this.toast = msg;
    if (this.toastTimer) clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => (this.toast = ''), 3200);
  }

  public submitted(p: PendingPlatePhoto): string {
    if (!p.submittedAt) return '';
    return new Date(p.submittedAt * 1000).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }

  public carLine(p: PendingPlatePhoto): string {
    return [p.make, p.model, p.colour].filter(Boolean).join(' · ');
  }
}
